import cx                   from 'classnames';
import React, { PropTypes } from 'react';
import ResizesImages        from 'mixins/resizes_images';
import VideoActions         from 'actions/video_actions';
import { isMobile }         from 'utils/util';

export default React.createClass({
  displayName: 'Player.Screen',
  propTypes: {
    videoElementId: PropTypes.string,
         isPlaying: PropTypes.bool,
        hasStarted: PropTypes.bool,
           isEnded: PropTypes.bool,
             video: PropTypes.object
  },
  mixins: [ ResizesImages ],
  componentDidMount() {
    VideoActions.load(this.props.videoElementId, this.props.video);
    this.newMount = true;
  },
  componentDidUpdate(prevProp) {
    if(prevProp.hasStarted === true) {
      // Akamai bugged. They probobly wont fix.
      // Our custom paused/play is more reliable so we use it to fix akamai.
      const       videoPlayer = document.getElementById(this.props.videoElementId),
            videoPlayerScreen = document.getElementById('video_player_screen'),
                  videoPoster = document.querySelector('.akamai-poster');

      if(videoPlayerScreen.classList.contains('is-paused')) {
        videoPlayer.classList.remove('akamai-ready'); 
        videoPlayer.classList.add('akamai-paused');
        if(videoPoster !== null && this.newMount === false && !isMobile()) {
          videoPoster.classList.add('fade-in');
          videoPoster.classList.remove('fade-out');
        }
      } else {
        videoPlayer.classList.remove('akamai-paused');
        videoPlayer.classList.remove('akamai-ready');
        if(videoPoster !== null && this.newMount === false && !isMobile()) {
          videoPoster.classList.remove('fade-in');
          videoPoster.classList.add('fade-out');
        }
      }
      if(videoPoster !== null) {
        if(this.newMount === true && !isMobile()) {
          videoPoster.classList.add('fade-out');
        }
        this.newMount = false;
      }
    }
  },
  toggle(e) {
    if(e.target.nodeName === 'OBJECT') return; // ignore events that are bubbling from the flash player
    // VideoActions.toggle();
  },
  render() {
    const { isPlaying, isEnded, videoElementId, video } = this.props,
          // so that the akamai player works outside of the React render chain
          akamaiDiv  = "<div class='content' id='" + videoElementId + "'></div>",
          style      = {
            // backgroundImage: isPlaying? null : `url(${video.poster})`
          },
          classes = cx({
                    'video-player-screen': true,
                              'is-paused': !isPlaying,
                               'is-ended': isEnded,
                         'has-title-card': video.hasTitleCard
                  });
    return (
      <div onTouchEnd={this.toggle}
           onClick={this.toggle}
           id="video_player_screen"
           className={classes}
           style={style}
           dangerouslySetInnerHTML={{__html: akamaiDiv}}></div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/player/screen.jsx
 **/